import CloudDashboard from "../images/CloudDashboard.png";
import Nexify from "../images/Nexify.png";
import CCTVDashboard from "../images/CCTVDashboard.png";
import GluTrend from "../images/GluTrend.png";
import PolicyStreet from "../images/PolicyStreet.png";
import pythonProgramme from "../images/PythonCISCO.jpg";
import pythonBasic from "../images/Python Basic.jpg";
import javascriptIntermediate from "../images/JavaScript.jpg";
import reactCertificate from "../images/ReactJS.jpg";
import IGITLogo from "../images/IGIT Logo.png";
import GACR from "../images/Government_Autonomous_College_Rkl.jpg";
import Chhend_Public_School from "../images/Chhend_Public_School.jpg";

export const Bio = {
	name: "Soumya Rn. Patra",
	roles: [
		"Python Developer",
		"Django Developer",
		"Software Engineer",
		"Full Stack Developer",
	],
	description: `
		I am a dynamic and motivated Python Developer with 3+ years of experience in building scalable web applications, RESTful APIs, and microservices using Python, Django, and React.js.
		Skilled in end-to-end development—from crafting robust backends to designing intuitive frontends—with strong expertise in MySQL, Docker, GCP, and Celery.
		I thrive on solving complex technical problems, optimizing performance, and deploying secure, high-availability systems in cloud environments.
		Passionate about continuous learning, I bring a growth mindset, positive attitude, and a commitment to delivering excellence in every project.
		`,
	github: "https://github.com/study-soumya",
	resume:
		"https://drive.google.com/file/d/1_-xEqKCopXbokGO0SVzV_Pdm_Cesmfn3/view?usp=sharing",
	linkedin: "https://www.linkedin.com/in/patra-soumya/",
	twitter: "https://twitter.com/Its_Soum_404",
	insta: "https://www.instagram.com/so_n_u_soum/",
	facebook: "https://www.facebook.com/SonuSoum69/",
};

export const skills = [
	{
		title: "Frontend",
		skills: [
			{
				name: "React Js",
				image:
					"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
			},
			{
				name: "HTML",
				image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
			},
			{
				name: "CSS",
				image:
					"https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
			},
			{
				name: "JavaScript",
				image:
					"https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
			},
			{
				name: "Bootstrap",
				image:
					"https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
			},
			{
				name: "jQuery",
				image: "https://cdn-icons-png.flaticon.com/128/16025/16025484.png",
			}
		],
	},
	{
		title: "Languages & Frameworks",
		skills: [
			{
				name: "Python",
				image:
					"https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
			},
			{
				name: "Django",
				image:
					"https://raw.githubusercontent.com/devicons/devicon/55609aa5bd817ff167afce0d965585c92040787a/icons/django/django-plain.svg",
			},
			{
				name: "Django REST Framework",
				image: "https://www.django-rest-framework.org/img/logo.png",
			},
			{
				name: "SQL",
				image: "https://cdn-icons-png.flaticon.com/128/2772/2772128.png",
			},
			
		],
	},
	{
		title: "Database",
		skills: [
			{
				name: "MySQL",
				image:
					"https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
			},
			{
				name: "SQLite",
				image: "https://cdn-icons-png.flaticon.com/128/14421/14421786.png"
			}
		],
	},
	{
		title: "Libraries & Tools",
		skills: [
			{
				name: "Celery",
				image:
					"https://cdn-icons-png.flaticon.com/128/2268/2268897.png",
			},
			{
				name: "Pandas",
				image:
					"https://raw.githubusercontent.com/devicons/devicon/master/icons/pandas/pandas-original-wordmark.svg",
			},
			{
				name: "NumPy",
				image:
					"https://raw.githubusercontent.com/devicons/devicon/master/icons/numpy/numpy-original-wordmark.svg",
			},
		],
	},
	{
		title: "Cloud & DevOps",
		skills: [
			{
				name: "Google Cloud Platform",
				image:
					"https://cdn-icons-png.flaticon.com/128/300/300221.png",
			},
			{
				name: "Docker",
				image:
					"https://cdn-icons-png.flaticon.com/128/15466/15466088.png",
			},
			{
				name: "GitHub",
				image:
					"https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
			},
			{
				name: "GitHub Actions",
				image:
					"https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
			},
			{
				name: "Nginx",
				image:
					"https://img.icons8.com/color/512/nginx.png",
			},
		]
	},
	{
		title: "Others",
		skills: [
			{
				name: "Netlify",
				image:
					"https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
			},
			{
				name: "VS Code",
				image:
					"https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
			},
		]
	}
];

export const experiences = [
	{
		id: 0,
		img: "https://aivolved.in/wp-content/uploads/2022/11/ai-logo.png",
		role: "Python Developer",
		company: "AiVolved Technologies Pvt. Ltd.",
		date: "Nov 2024 - Present",
		desc: "Currently working as a Python Developer at AiVolved Technologies Pvt. Ltd. with hands-on experience in building scalable, responsive web applications and RESTful APIs using Django and React.js. Played a key role in deploying microservices on GCP with Docker, optimizing MySQL databases, and integrating real-time data solutions. Delivered high-performance applications for AI-based surveillance, healthcare, and visual dashboards. Proficient in cloud deployment, containerization, and agile methodologies, contributing to multiple cross-functional projects that improved performance, scalability, and user engagement.",
		skills: ["Python", "Django", "Django REST Framework", "MySQL", "Celery", "Redis", "WebSocket", "JWT", "Nginx", "SMTP", "Docker", "React.js", "GCP", "RTSP", "FFmpeg", "AES-256", "Swagger", "OpenCV"],
	},
	{
		id: 1,
		img: "https://media.licdn.com/dms/image/v2/C510BAQFrj0PtUIEf5Q/company-logo_100_100/company-logo_100_100/0/1630585684813/quantumware_logo?e=1757548800&v=beta&t=bRLjAGdeaqEsS_KmULuKItZLy3UVN9-EUzweDAI3Wv8",
		role: "Software Engineer",
		company: "Quantumware Technical Services Pvt. Ltd.",
		date: "Jan 2022 - Oct 2024",
		desc: "Worked as a Software Engineer focusing on full-stack web development using Python (Django), React.js, and RESTful APIs. Led the development of parental control and insurance management applications, supporting thousands of active users. Contributed to backend optimization, real-time data handling, and secured API integrations. Improved team efficiency by enhancing collaboration and reducing delivery timelines. Played a critical role in solving complex technical issues, optimizing database performance, and integrating automated workflows for scalable application deployment.",
		skills: ["Python", "Django", "Django REST Framework", "MySQL", "Celery", "Redis", "WebSocket", "JWT", "Nginx", "SMTP", "Docker", "React.js", "AWS"],
	},
];

export const projects = [
	{
		id: 0,
		title: "Vision Intelligence Dashboard",
		company: "AiVolved Technologies Pvt. Ltd.",
		date: "Nov 2024 - Present",
		description:
			"Developed RESTful APIs and microservices for real-time data visualization using Django and React.js. Optimized MySQL queries, integrated AES-256 encryption, and deployed the system on GCP with Docker and Celery to handle 120GB+ daily visual data.",
		image: CloudDashboard,
		tags: ["Python", "Django REST Framework", "MySQL", "Celery", "Redis", "WebSocket", "Nginx", "Docker", "React.js", "AES-256", "GCP"],
		category: "web app",
	},
	{
		id: 1,
		title: "Camera-Based AI Detection Tool",
		company: "AiVolved Technologies Pvt. Ltd.",
		date: "Apr 2025 - Present",
		description:
			"Designed and implemented backend architecture for AI-powered anomaly detection using Django REST Framework and React.js. Scaled application across multiple regions using GCP and handled 1,000+ concurrent users with secure, interactive dashboards.",
		image: Nexify,
		tags: ["Python", "Django REST Framework", "React.js", "Docker", "GCP"],
		category: "tools",
	},
	{
		id: 2,
		title: "GluTrend – Glucose Monitoring Mobile Application",
		company: "AiVolved Technologies Pvt. Ltd.",
		date: "Jan 2025 - Apr 2025",
		description:
			"Created secure APIs to process Bluetooth-based glucose readings in real time with 99% accuracy. Enabled OTP-based authentication, improved MySQL retrieval speeds by 30%, and automated onboarding for 1,000+ medical camp users.",
		image: GluTrend,
		tags: ["Python", "Django REST Framework", "React.js", "Docker", "Nginx", "SMTP", "JWt","GCP"],
		category: "mobile app",
	},
	{
		id: 3,
		title: "CCTV Camera Feed Dashboard – Surveillance Monitoring System",
		company: "AiVolved Technologies Pvt. Ltd.",
		date: "Dec 2024 - Feb 2025",
		description:
			"Built a real-time surveillance system using RTSP and FFmpeg to stream multiple CCTV feeds with <300ms latency. Developed scalable APIs and UI for section-wise camera management, improving monitoring efficiency by 50%.",
		image: CCTVDashboard,
		tags: ["Python", "Django REST Framework", "React.js", "FFmpeg", "RTSP", "WebSocket", "Celery", "Python GUI", "SMTP"],
		category: "web app",
	},
	{
		id: 4,
		title: "PolicyStreet",
		company: "Quantumware Technical Services Pvt. Ltd.",
		date: "Jan 2022 - Oct 2024",
		description:
			"Developed an admin dashboard for insurance policy management using Django and MySQL. Automated policy workflows, added real-time email alerts, and improved dashboard load times by 35% through backend optimization and access control.",
		image: PolicyStreet,
		tags: ["Python", "Django REST Framework", "React.js", "Docker", "SMTP", "MySQL", "WebSocket", "Celery", "AWS"],
		category: "web app",
	}
];

export const certifications = [
	{
		id: 0,
		img: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/HackerRank_Icon-1000px.png/800px-HackerRank_Icon-1000px.png",
		role: "Python (Basic)",
		company: "HackerRank",
		date: "Oct 2023",
		desc: "Certification of Python (Basic) Skill Assessment by HackerRank.",
		skills: ["Python"],
		doc: pythonBasic,
	},
	{
		id: 1,
		img: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/HackerRank_Icon-1000px.png/800px-HackerRank_Icon-1000px.png",
		role: "JavaScript (Intermediate)",
		company: "HackerRank",
		date: "Oct 2023",
		desc: "Certification of JavaScript (Intermediate) Skill Assessment by HackerRank.",
		skills: ["JavaScript"],
		doc: javascriptIntermediate,
	},
	{
		id: 2,
		img: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/HackerRank_Icon-1000px.png/800px-HackerRank_Icon-1000px.png",
		role: "Frontend Developer (React)",
		company: "HackerRank",
		date: "Oct 2023",
		desc: "Certification of Frontend Developer (React) Skill Assessment by HackerRank.",
		skills: ["ReactJS", "JavaScript", "CSS"],
		doc: reactCertificate,
	},
	{
		id: 3,
		img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Cisco_academy_logo.svg/1200px-Cisco_academy_logo.svg.png",
		role: "Python Programme",
		company: "CISCO Networking Academy",
		date: "June 2021 - July 2021",
		desc: "Built an Personal Assistant - JARVIS AI using Python fundamentals and advanced topics like Multithreading, Exception Handling, and File Handling.",
		skills: ["Python Fundamentals", "Advance Python", "PyQT"],
		doc: pythonProgramme,
	}
];

export const education = [
	{
		id: 0,
		img: IGITLogo,
		school: "Indira Gandhi Institute of Technology, Sarang, Odisha",
		date: "Aug 2018 - May 2022",
		grade: "7.99 CGPA",
		desc: "I hold a Bachelor's degree in Computer Science and Engineering from Indira Gandhi Institute of Technology, Sarang, with a final semester CGPA of 7.99. My academic coursework encompassed a comprehensive array of core subjects, including Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among other relevant topics.",
		degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
	},
	{
		id: 1,
		img: GACR,
		school: "Government Junior College, Rourkela, Odisha",
		date: "Aug 2016 - May 2018",
		grade: "68.33%",
		desc: "I completed my class Higher Secondary Education at Government Junior College, Rourkela, where I pursued a Science curriculum with a focus on Statistics.",
		degree: "CHSE(XII), Science with Statistics",
	},
	{
		id: 2,
		img: Chhend_Public_School,
		school: "Chhend Public School, Rourkela, Odisha",
		date: "May 2016",
		grade: "81.13%",
		desc: "My foundational education took place at Chhend Public School, Rourkela, where I successfully completed my Class 10 studies.",
		degree: "BSE(X)",
	}
];